import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeService } from '../../Services/theme.service';

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [MatIconModule, TranslateModule],
  templateUrl: './theme-toggle.component.html',
  styleUrls: ['./theme-toggle.component.scss'],
})
export class AvThemeToggleComponent {
  public themeService = inject(ThemeService);

  isDark(): boolean {
    return this.themeService.mode() === 'dark';
  }

  toggle(): void {
    this.themeService.toggleMode();
  }

  setTheme(mode: 'light' | 'dark'): void {
    if (this.themeService.mode() !== mode) {
      this.themeService.toggleMode();
    }
  }
}
